"use strict";

exports.__esModule = true;
exports.default = void 0;

var _formData = _interopRequireDefault(require("../condition/formData"));

var _formData2 = _interopRequireDefault(require("../damage/formData"));

var _formData3 = _interopRequireDefault(require("../task/formData"));

var _formData4 = _interopRequireDefault(require("../work/formData"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = {
  "documentType": "building",
  "createdAt": "2019-11-26T08:56:00",
  "updatedAt": "2020-02-09T19:21:54",
  "uniqueId": "cecf8432-f8e9-43a1-9e00-f1abfb8c86f3",
  "title": "Søre Hage",
  "content": {
    "documentType": "building",
    "objectId": "SS-U-05",
    "title": "Søre Hage",
    "condition": [_formData.default, _formData.default, _formData.default],
    "damage": [_formData2.default, _formData2.default, _formData2.default, _formData2.default],
    "task": [_formData3.default, _formData3.default, _formData3.default, _formData3.default, _formData3.default, _formData3.default, _formData3.default],
    "work": [_formData4.default, _formData4.default, _formData4.default, _formData4.default, _formData4.default],
    "media": [{
      "media": {
        "resources": {
          "png": {
            "url": "https://dms-test.dimu.org/image/012uP2P9GrRA?mediaType=image%2Fpng",
            "mimeType": "image/png"
          },
          "original": {
            "url": "https://dms-test.dimu.org/image/012uP2P9GrRA?dimension=original"
          },
          "jpeg": {
            "url": "https://dms-test.dimu.org/image/012uP2P9GrRA",
            "mimeType": "image/jpeg"
          },
          "properties": {
            "url": "https://dms-test.dimu.org/properties/012uP2P9GrRA",
            "mimeType": "application/json"
          }
        },
        "mediaHeight": 646,
        "mediaSize": 0,
        "identifier": "012uP2P9GrRA",
        "collectionId": 53,
        "referenceCount": 0,
        "uploadUrl": "https://dms-test.dimu.org:8443/upload?aId=Q4yC8D7DLC7e5s1AT6ryyHGPzgQCAT9rW12uxihiYdpyQwNRt&public=true",
        "description": "",
        "imageSize": 0,
        "title": "koongens-nei.jpeg",
        "createdAt": "2020-03-06T14:40:14",
        "content": {
          "creatorJobtitle": "",
          "creator": "",
          "description": "",
          "descriptionWriter": "",
          "title": "koongens-nei.jpeg",
          "filename": "koongens-nei.jpeg",
          "keywords": "",
          "headline": "",
          "creditLine": ""
        },
        "mediaType": "image",
        "uploadStatus": "done",
        "imageUrl": "https://dms-test.dimu.org/image/012uP2P9GrRA?mediaType=image/png",
        "uniqueId": "6e194222-521f-4840-bba4-edb52e2467c2",
        "imageHeight": 646,
        "mimeType": "image/jpeg",
        "status": "draft",
        "updatedAt": "2020-03-06T14:40:18",
        "mediaWidth": 1150,
        "id": 1228,
        "imageType": "png",
        "imageWidth": 1150,
        "mediaUrl": "https://dms-test.dimu.org/image/012uP2P9GrRA"
      },
      "mediaId": "6e194222-521f-4840-bba4-edb52e2467c2"
    }, {
      "media": {
        "resources": {
          "png": {
            "url": "https://dms-test.dimu.org/image/012uP2P9GrRB?mediaType=image%2Fpng",
            "mimeType": "image/png"
          },
          "original": {
            "url": "https://dms-test.dimu.org/image/012uP2P9GrRB?dimension=original"
          },
          "jpeg": {
            "url": "https://dms-test.dimu.org/image/012uP2P9GrRB",
            "mimeType": "image/jpeg"
          },
          "properties": {
            "url": "https://dms-test.dimu.org/properties/012uP2P9GrRB",
            "mimeType": "application/json"
          }
        },
        "mediaHeight": 254,
        "mediaSize": 0,
        "identifier": "012uP2P9GrRB",
        "collectionId": 53,
        "referenceCount": 0,
        "uploadUrl": "https://dms-test.dimu.org:8443/upload?aId=PYxH7yn4WB2FECLUfZZXLDX6WcHG9RwKogc7Dr5o25Xxaz1Gg&public=true",
        "description": "",
        "imageSize": 0,
        "title": "kongen3.jpeg",
        "createdAt": "2020-03-06T14:45:17",
        "content": {
          "creatorJobtitle": "",
          "creator": "",
          "description": "",
          "descriptionWriter": "",
          "title": "kongen3.jpeg",
          "filename": "kongen3.jpeg",
          "keywords": "",
          "headline": "",
          "creditLine": ""
        },
        "mediaType": "image",
        "uploadStatus": "done",
        "imageUrl": "https://dms-test.dimu.org/image/012uP2P9GrRB?mediaType=image/png",
        "uniqueId": "ce0fb959-1454-47b8-a92e-75d1d5002239",
        "imageHeight": 254,
        "mimeType": "image/jpeg",
        "status": "draft",
        "updatedAt": "2020-03-06T14:45:27",
        "mediaWidth": 180,
        "id": 1229,
        "imageType": "png",
        "imageWidth": 180,
        "mediaUrl": "https://dms-test.dimu.org/image/012uP2P9GrRB"
      },
      "mediaId": "ce0fb959-1454-47b8-a92e-75d1d5002239"
    }]
  },
  "imageUrl": "https://dms-test.dimu.org/image/012uNXVpKSwt?mediaType=image/png",
  "description": "",
  "id": 944,
  "parent": null,
  "status": "publish",
  "referenceCount": 0,
  "collectionId": 145,
  "schemaId": 57,
  "locale": "no"
};
exports.default = _default;
module.exports = exports.default;